import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlCountryListRequest } from "../models/service-models/country/CountryListRequest";
import { mdlCountryListResponse } from "../models/service-models/country/CountryListResponse";
import { GetResponse } from "../utils/ApiClient";

namespace CountryService {
    export async function List(
        pRequest: mdlCountryListRequest
    ): Promise<mdlServiceResponse<mdlCountryListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlCountryListResponse>>(
            "country/list",
            pRequest
        );
    }
}
export { CountryService };
